<template lang="pug">
  v-container.notification-bar(fluid)
    VIcon.v-icon--warn icon-warn
    .notification-bar__message {{ text }}
    VIcon.v-icon--close(
      @click="$emit('close')"
    ) icon-close

</template>

<script>
export default {
  name: 'NotificationBar',
  props: {
    type: { type: String, default: 'error' },
    text: { type: String, default: '' },
  },
};
</script>

<style lang="scss">
.notification-bar {
  position: absolute;
  bottom: 80px;
  z-index: 4;
  height: 80px;
  background: $light-red;
  color: $white;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .v-icon--warn {
    color: $black !important;
    font-size: 2rem !important;
    margin-right: 20px;
  }

  .v-icon--close {
    position: absolute !important;
    top: -17px;
    right: 40px;
    font-size: 0.875rem !important;
    background: $black;
    color: $white !important;
    padding: 10px;
    border-radius: 50%;
  }

  .notification-bar__message {
    color: $black;
    font-size: 1.25rem;
    font-weight: 700;

    &:first-letter {
      text-transform: uppercase;
    }
  }
}
</style>
